<template>
    <div>

        <v-dialog
            v-model="display"
            width="500"
            persistent>
            <v-tabs
                v-model="tab"
                grow>
                <v-tab>{{ $t("ROLE_TAB_GENERAL") }}</v-tab>
                <v-tab>{{ $t("ROLE_TAB_PERMISSIONS") }}</v-tab>
            </v-tabs>
            <v-tabs-items
                v-model="tab">
                <v-tab-item>
                    <v-card>
                        <v-card-title>{{title}}</v-card-title>
                        <v-card-subtitle>{{ $t("ROLE_TAB_GE_SUBT") }}</v-card-subtitle>
                        <v-card-text>
                            <v-progress-circular
                                indeterminate
                                v-if="!dataLoaded"
                                color="primary">
                            </v-progress-circular>
                            <div v-if="dataLoaded">
                                <v-form
                                    ref="form"
                                    v-model="valid">    
                                    <v-text-field
                                        :label="$t('ROLE_NAME')"
                                        v-model="form.name"
                                        :rules="rules.name"
                                        :disabled="uneditableField('name')">
                                    </v-text-field>
                                    <v-select
                                        :label="$t('ROLE_WORKSHOP')"
                                        :items="workshops"
                                        item-text="name"
                                        item-value="id"
                                        v-model="form.workshop_id"
                                        :disabled="uneditableField('workshop_id')">
                                    </v-select>

                                    <v-switch
                                        :label="$t('ROLE_DISABLE')"
                                        v-model="form.inactive"
                                        v-if="editMode">
                                    </v-switch>
                                </v-form>
                            </div>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                text
                                :disabled="!valid"
                                @click="submit">
                                {{ $t("BTN_SAVE") }}                  
                            </v-btn>
                            <v-btn
                                text
                                @click="close">
                                {{ $t("BTN_CANCEL") }}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <v-card>
                        <v-treeview
                            v-model="form.permissions"
                            selectable
                            selected-color="primary"
                            :items="permissions">
                        </v-treeview>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </v-dialog>
        <AlertDialog
            ref="alertDialog"/>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import AlertDialog from '../components/AlertDialog';
import uneditableField from '../utils/uneditableField';
export default {
    name: "PermissionDialog",
    components: {
        AlertDialog
    },
    data() {
        return {
            display: false,
            editMode: false,
            valid: false,
            dataLoaded: false,
            tab: null,
            form: {
                id: null,
                name: null,
                inactive: false,
                permissions: []
            },
            rules: {
                name: [
                    v => !!v || this.$t("RULES_REQUIRED_MSG")
                ]
            }
        }
    },
    computed: {
        ...mapState("workshop", ["workshops"]),
        ...mapState("permission", ["permissions"]),
        ...mapState("role", ["role"]),
         ...mapState('authentication', ["workshopId"]),
        title() {
            if(!this.editMode) return this.$t("ROLE_TAB_GE_NEW_TIT");
            else return this.$t("ROLE_TAB_GE_EDIT_TIT");
        }
    },
    methods: {
        uneditableField,
        ...mapActions("workshop", ["fetchAll"]),
        ...mapActions("permission", ["fetchPermissions"]),
        ...mapActions("role", ["storeRole", "fetchRoles", "updateRole", "fetchRole"]),
        ...mapActions('authentication', ["fetchAuthorizations"]),
        async open(params) {
            this.display = true;
            this.editMode = params.editMode;
            await Promise.all([this.fetchAll(), this.fetchPermissions()]);
            if(this.editMode) {
                await this.fetchRole(params.id);
                this.form = this.role;
            }
            this.dataLoaded = true;
        },
        close() {
            this.display = false;
            this.dataLoaded = false;
            this.$refs.form.reset();
            this.form.permissions = [];
            this.$refs.form.resetValidation();
        },
         submit() {
            if(!this.editMode) {
                this.storeRole(this.form)
                    .then(async response => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t("SUCCESS_TITLE"), response.message);
                        await Promise.all([this.fetchAuthorizations(this.workshopId),  this.fetchRoles()]);
                    })
                    .catch(error => {
                        this.$refs.alertDialog.open(this.$t("ERROR_TITLE"), error.message);
                    })
            } else {
                this.updateRole(this.form)
                    .then(async response => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t("SUCCESS_TITLE"), response.message);
                        await Promise.all([this.fetchAuthorizations(this.workshopId),  this.fetchRoles()]);
                    })
                    .catch(error => {
                        this.$refs.alertDialog.open(this.$t("ERROR_TITLE"), error.message);
                    })
            }
        }
    }
}
</script>